module.exports = __webpack_public_path__ + "img/certificateBg.696c981c.jpg";